export const SUCCESS_MSG_SHOW_NOTIFICATION_SUPPORT_FORM =
  'Your request has been raised & successfully submitted, Our experts will reach back to you shortly!'

export const ERROR_MSG_SHOW_NOTIFICATION_SUPPORT_FORM =
  'Unfortunately we could not create the request :( Try again or Write us to gargantua-support@target.com'

export const ERROR_MSG_FOR_WRONG_FILE_UPLOAD_SUPPORT_FORM =
  'Please upload only JPG, JPEG, PNG and GIF file'

export const ERROR_MSG_FOR_DESCRIPTION_SUPPORT_FORM =
  'Please write the issue here'

export const SUCCESS_MSG_SHOW_COMPLETION_OF_TASK =
  'TCIN has been submitted for review. Goodluck!'

export const DESCRIPTION_TEXT_TASK =
  ' are you sure you have completed the task ?'

export const CONFIRM_TEXT_TASK = 'YES, SUBMIT FOR REVIEW'

export const CANCEL_TEXT_TASK = 'NO, I AM STILL WORKING'

export const DESCRIPTION_TEXT_REVIEW =
  ' are you sure you have completed reviewing the TCIN ?'

export const CONFIRM_TEXT_REVIEW = 'YES, I AM DONE REVIEWING'

export const ERROR_MSG_FOR_APPLICATION_MAINTENANCE_MAIN =
  "Sorry, we're upgrading the system at the moment..."

export const ERROR_MSG_FOR_APPLICATION_MAINTENANCE_SUB =
  'Gargantua is temporarily unavailable while we make upgrades to improve the service for you. Inconvenience is regretted.'

export const ERROR_MSG_FOR_API_DOWN =
  "Opps! We're sorry, but we're experiencing a problem on our end"

export const ERROR_MSG_FOR_ACCESS_DENIED =
  "Don't worry! We think you're lost. Incase you aren't <br /> contact Admin & get access to this project"

export const TCIN_VARIATION_TITLE =
  'Do you want to assign the same artist to the variations of the selected TCINs?'

export const TCIN_EXISTS_IN_PROJECT = 'TCIN already present in Project'
